module.exports = "/_next/static/images/logo-fastpay-4a1eccf242648ac63faffc1032479403.png";